exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/nastavnejedinice-popis/nastavnejedinice-popis.component.css
// module id = ../../../../../src/app/pages/virtualna-ucionica/nastavnejedinice-popis/nastavnejedinice-popis.component.css
// module chunks = main